import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { BrokenContainerReportFieldsFragmentDoc } from '../fragments/brokenContainerReport.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BrokenContainerReportsQueryVariables = Types.Exact<{
  storeId: Types.Scalars['ID'];
  days?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type BrokenContainerReportsQuery = { __typename?: 'Query', brokenContainerReports: Array<{ __typename?: 'BrokenContainerReport', id: string, store_id: string, store_name?: string | null, context: Types.BrokenContainerReportContext, merchant_order_id?: string | null, merchant_order_delivery_note_id?: number | null, comment?: string | null, created_at: string, created_by?: string | null, container_total: number, lines: Array<{ __typename?: 'BrokenContainerLine', id: string, container_type_id: number, container_type_name?: string | null, image_url?: string | null, amount: number, part: Types.BrokenContainerPart, active?: boolean | null, cleared_at?: string | null, cleared_by?: string | null, container?: { __typename?: 'ReturnOrderContainer', id: string, name?: string | null, short_id?: string | null } | null, photos: Array<{ __typename?: 'OrderFulfillmentPicture', id: string, url_full_size: string, created_at: string, thumbnail_url: string }> }>, photos: Array<{ __typename?: 'OrderFulfillmentPicture', id: string, url_full_size: string, created_at: string, thumbnail_url: string }> }> };


export const BrokenContainerReportsDocument = gql`
    query BrokenContainerReports($storeId: ID!, $days: Int) {
  brokenContainerReports(store_id: $storeId, days: $days) {
    ...BrokenContainerReportFields
  }
}
    ${BrokenContainerReportFieldsFragmentDoc}`;

/**
 * __useBrokenContainerReportsQuery__
 *
 * To run a query within a React component, call `useBrokenContainerReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrokenContainerReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrokenContainerReportsQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useBrokenContainerReportsQuery(baseOptions: Apollo.QueryHookOptions<BrokenContainerReportsQuery, BrokenContainerReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrokenContainerReportsQuery, BrokenContainerReportsQueryVariables>(BrokenContainerReportsDocument, options);
      }
export function useBrokenContainerReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrokenContainerReportsQuery, BrokenContainerReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrokenContainerReportsQuery, BrokenContainerReportsQueryVariables>(BrokenContainerReportsDocument, options);
        }
export type BrokenContainerReportsQueryHookResult = ReturnType<typeof useBrokenContainerReportsQuery>;
export type BrokenContainerReportsLazyQueryHookResult = ReturnType<typeof useBrokenContainerReportsLazyQuery>;
export type BrokenContainerReportsQueryResult = Apollo.QueryResult<BrokenContainerReportsQuery, BrokenContainerReportsQueryVariables>;